import { isConsumerApp } from '@loggi/js/mobile';
import React from 'react';
import Col from '@loggi/ui/components/col';
import Button from '@loggi/ui/components/button';
import { ROUNDED_SHAPE } from '@loggi/ui/components/button/types';
import Text, {
  TEXT_SIZE_LARGE,
  TEXT_SIZE_REGULAR
} from '@loggi/ui/components/text';
import { APP_BEYOND_CONTENT } from 'tracker.constants';
import Image from '@loggi/ui/components/image';
import appBeyond from 'images/package.png';
import colors from '@loggi/ui/components/utils/colors';

const url = 'https://www.loggi.com/produtos-loggi/';

const _isConsumerApp = isConsumerApp();

export const AppBeyondMobile = () => {
  if (_isConsumerApp) {
    return <Col />;
  }

  return (
    <Col flex className="app-beyond-content-mobile">
      <Col size={12}>
        <Col className="title-content mobile-title-space">
          <Text bold color={colors.type.WHITE} size={TEXT_SIZE_LARGE}>
            {APP_BEYOND_CONTENT.title}
          </Text>
        </Col>
        <Col className="text-content mobile-text-space">
          <Text small color={colors.type.WHITE} size={TEXT_SIZE_REGULAR}>
            {APP_BEYOND_CONTENT.textContent}
          </Text>
        </Col>
        <Col size={{ xs: 4, md: 4, lg: 2, xl: 2, xxl: 2 }}>
          <Button
            data-testid={APP_BEYOND_CONTENT.buttonMobile}
            block
            value={APP_BEYOND_CONTENT.buttonContent}
            onClick={() => window.open(url, '_blank', 'noopener')}
            style="outline"
            shape={ROUNDED_SHAPE}
            className="beyond-button-img"
          />
        </Col>
        <Col className="beyond-image">
          <Image src={appBeyond} noBackgroundColor />
        </Col>
      </Col>
    </Col>
  );
};

export const AppBeyond = () => {
  return (
    <Col size={{ md: 6, lg: 6, xl: 10, xxl: 10 }} className="app-beyond">
      <Col size={12} className="app-beyond-content">
        <Col className="title-content">
          <Text bold color={colors.type.WHITE} size={TEXT_SIZE_LARGE}>
            {APP_BEYOND_CONTENT.title}
          </Text>
        </Col>
        <Col className="text-content">
          <Text small color={colors.type.WHITE} size={TEXT_SIZE_REGULAR}>
            {APP_BEYOND_CONTENT.textContent}
          </Text>
        </Col>
        <Col size={{ xs: 4, md: 4, lg: 2, xl: 2, xxl: 2 }}>
          <Button
            data-testid={APP_BEYOND_CONTENT.buttonWeb}
            block
            value={APP_BEYOND_CONTENT.buttonContent}
            onClick={() => window.open(url, '_blank', 'noopener')}
            style="outline"
            shape={ROUNDED_SHAPE}
            className="beyond-button-img"
          />
        </Col>
      </Col>
    </Col>
  );
};

export default { AppBeyondMobile, AppBeyond };
